/* eslint-disable import/prefer-default-export */
import { adminLoginUrl } from '../urls';

export async function postAdminLogin(user, secret) {
  const data = {
    user,
    secret,
  };
  const response = await fetch(adminLoginUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  return response;
}
